<template>
  <span>
    <v-list-item
      link
      :to="{ name: item.link, params: item.vendorCode ? {
        vendorId: item.vendorCode
      } : {
        endsWith: item.endsWith
      }}"
      :class="
        ((item.link == 'Company.DocumentPOAI' || item.link == 'Company.DocumentSOAI')  && !isPdfDoc) || item.link === 'Company.DocumentsPurchase' && companyID === 'pvfyTLwab5Dsef5fKEnV'
          ? 'hide'
          : ''
      "
    >
      <v-list-item-icon>
        <img
          v-if="item.icon"
          :src="'/images/icons/' + item.icon"
          class="menu-icon"
        />
        <img
          v-if="item.icon_active"
          :src="'/images/icons/' + item.icon_active"
          class="menu-icon"
        />
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title  v-if="!item.icon" class="tw-ml-1 tw-flex tw-gap-2 tw-items-center">
          <img
          v-if="item.subIcon"
          :src="item.subIcon"
          class="tw-w-6 tw-h-6 tw-object-contain"
        />
          {{ item.text }}
        </v-list-item-title>
        <v-list-item-title v-else >
          {{ item.text }}
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <!--  <v-list-item v-for="submenu in item.subLinks" :key="submenu.text" link :to="{name: submenu.link}">-->
    <!--    <v-list-item-icon></v-list-item-icon>-->
    <!--    <v-list-item-content>-->
    <!--      <v-list-item-title>-->
    <!--        {{ submenu.text }}-->
    <!--      </v-list-item-title>-->
    <!--    </v-list-item-content>-->
    <!--  </v-list-item>-->
  </span>
</template>

<script>
export default {
  name: "list",
  props: ["item", "companyID","isPdfDoc"],

};
</script>

<style scoped lang="scss">
.hide {
  display: none;
}

.menu-icon {
  width: 22px;
  height: 20px;
  margin-left: 40%;
}

.v-list-item--link:before {
  background-color: #ffffff;
}

.v-list-item__icon {
  img:nth-child(2) {
    display: none;
  }
}

.v-list-item {
  margin-left: 10px;
}

.v-list-item--active:first-child {
  background-color: #c9242b;
  color: #ffffff;
  position: relative;
  border-top-left-radius: 30px;
  border-bottom-left-radius: 30px;
  margin-left: 10px;

  //&:before {
  //  opacity: 1;
  //  content: "";
  //  width: 4px;
  //  position: absolute;
  //  left: 0;
  //  top: 0;
  //  bottom: 0;
  //  background-color: #c9242b;
  //  border-top-right-radius: 5px;
  //  border-bottom-right-radius: 5px;
  //}

  .v-list-item__icon {
    img:nth-child(1) {
      display: none;
    }

    img:nth-child(2) {
      display: block;
    }
  }
}
</style>
